import { CrudCollectionPage, type CrudRecord } from "./CrudCollectionPage";
import { runtimeConfig } from "../config";
import { Show } from "solid-js";
import { hasPermission } from "../core/session";

export function SharedReportsPage() {
  return (
    <CrudCollectionPage
      label="Shared Reports"
      singular="Shared Report"
      endpoint="/shared-reports"
      icon="nav_legislation"
      search={false}
      advancedSearch={false}
      canUpdate={false}
      canDelete={hasPermission("shared-reports.delete")}
      fields={[
        { key: "reportId", label: "Report ID", readOnly: true },
        { key: "reportType", label: "Type", readOnly: true },
        { key: "createdAt", label: "Shared At", readOnly: true },
        { key: "expiresAt", label: "Expires At", readOnly: true },
      ]}
      itemTitle={(item) => nested(item, "report", "title")}
      itemDescription={(item) => nested(item, "report", "description")}
      itemLeftLabel={(item) => `ID: ${value(item.reportId)}`}
      itemRightLabel={(item) =>
        `${nested(item, "report", "firstName")} ${nested(item, "report", "lastName")} - ${date(item.createdAt)}`
      }
      renderAfterFields={(item) => (
        <section class="bg-[rgba(255,255,255,.04)] p-4">
          <p class="mb-2 roboto500">{nested(item, "report", "title")}</p>
          <p class="whitespace-pre-wrap text-white-55">
            {nested(item, "report", "description")}
          </p>
          <Show
            when={item.sharedTo == null}
            fallback={<p class="mt-4 text-sm text-white-55">Shared to MDT user #{value(item.sharedTo)}</p>}
          >
            <button
              class="mt-4 border border-white-11 bg-[rgba(0,248,185,.12)] px-3 py-2 text-sm text-cyan hover:bg-[rgba(0,248,185,.25)]"
              onClick={() => void copyPublicLink(String(item.id ?? ""))}
            >
              Copy public record link
            </button>
          </Show>
        </section>
      )}
    />
  );
}

async function copyPublicLink(id: string) {
  if (!id) return;
  await navigator.clipboard.writeText(
    `${runtimeConfig.publicOrigin}/public/records/${id}`,
  );
}

function nested(item: CrudRecord, key: string, child: string): string {
  const parent = item[key];
  return parent && typeof parent === "object"
    ? value((parent as CrudRecord)[child])
    : "";
}
function value(input: unknown): string {
  return typeof input === "string" || typeof input === "number"
    ? String(input)
    : "";
}
function date(input: unknown): string {
  const valueString = value(input);
  return valueString ? new Date(valueString).toLocaleString() : "";
}
